import { createContext, useContext, useMemo, type PropsWithChildren } from 'react';
import { Container, ConsoleLogger, createToken, type ILogger } from '@ah/core';

export const LOGGER = createToken<ILogger>('Logger');
export const API_BASE_URL = createToken<string>('ApiBaseUrl');

const DiContext = createContext<Container | null>(null);

export function buildAppContainer(): Container {
  const container = new Container();
  container.register(LOGGER, () => new ConsoleLogger({ level: import.meta.env.DEV ? 'debug' : 'warn' }));
  container.registerValue(API_BASE_URL, import.meta.env.VITE_API_URL ?? 'http://localhost:4000');
  return container;
}

export function DiProvider({ children, container }: PropsWithChildren<{ container?: Container }>) {
  const value = useMemo(() => container ?? buildAppContainer(), [container]);
  return <DiContext.Provider value={value}>{children}</DiContext.Provider>;
}

export function useDi(): Container {
  const ctx = useContext(DiContext);
  if (!ctx) throw new Error('useDi must be used inside <DiProvider>');
  return ctx;
}
